<app-metric-card
  [title]="cardTitle"
  [currentValue]="mttdData().value !== null ? mttdData().value : 0"
  [suffix]="suffix"
  [hidePrevious]="true"
  [hideComparison]="true"
  [isLoading]="isLoading()"
></app-metric-card>
